import {
  Paper,
  type PaperProps,
  Table,
  type TableProps,
  TableContainer,
  type TableContainerProps,
} from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";
import React from "react";

import { unifiedTableSx } from "./unifiedTableSx";

interface AdminTableFrameProps {
  children: React.ReactNode;
  containerProps?: Omit<TableContainerProps, "children" | "component">;
  elevation?: PaperProps["elevation"];
  tableProps?: Omit<TableProps, "children" | "sx">;
  tableSx?: SxProps<Theme>;
}

/** Shared Paper and visual treatment for standalone admin list tables. */
export const AdminTableFrame: React.FC<AdminTableFrameProps> = ({
  children,
  containerProps,
  elevation = 1,
  tableProps,
  tableSx,
}) => {
  const resolvedTableSx: SxProps<Theme> = tableSx
    ? [unifiedTableSx, ...(Array.isArray(tableSx) ? tableSx : [tableSx])]
    : unifiedTableSx;

  return (
    <TableContainer component={Paper} elevation={elevation} {...containerProps}>
      <Table {...tableProps} sx={resolvedTableSx}>
        {children}
      </Table>
    </TableContainer>
  );
};
